import Todo from './components/Todo'
import './App.css';

function App() {
  return (
    <>
      <Todo/>
    </>
  );
}

export default App;
